import { styled } from '@mui/material';

export const CarouselContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  overflowX: 'scroll',
  overflowY: 'hidden',
}));

export const SkeletonCarouselContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2),
  overflowX: 'hidden',
  overflowY: 'hidden',
}));

export const CarouselScrollContainer = styled('div')(({ theme }) => ({
  display: 'inline-flex',
  padding: theme.spacing(1),
}));

export const TileContainer = styled('div')(() => ({}));
